import { createContext, useContext } from 'react';
import { logger } from '../services/logger.client';

export interface ConfirmOptions {
  message: React.ReactNode;
  onConfirm: () => void;
  title?: string;
  okText?: string;
  cancelText?: string;
  isAuthModal?: boolean;
}

export interface ConfirmationContextType {
  confirm: (options: ConfirmOptions) => void;
  isAuthConfirming: boolean;
}

export const ConfirmationContext = createContext<ConfirmationContextType | null>(null);

// Create a mutable ref object that can be updated by the provider.
// This allows legacy code to call the confirm modal from outside React components.
export const confirmModal: { current: (options: ConfirmOptions) => void } = {
  current: () => {
    logger.warn('Attempted to use confirmModal before it was initialized.');
  },
};

export const useConfirmation = () => {
  const context = useContext(ConfirmationContext);
  if (!context) {
    throw new Error('useConfirmation must be used within a ConfirmationProvider');
  }
  return context;
};